/**
 * HomepageVenueMap ✦ iter229 — compact preview of the full venue
 * map for the editorial homepage. Auto-hides until at least one
 * event pin exists, so a fresh deploy never shows an empty map.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import VenueMap from './VenueMap';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const SERIF = 'Georgia, "Cormorant Garamond", "Times New Roman", serif';
const IVORY = '#FBEED0';
const IVORY_DIM = 'rgba(251,238,208,0.72)';
const GOLD = '#D4AF5E';
const WALNUT = '#0E0805';

const HomepageVenueMap = () => {
  const [hasPins, setHasPins] = useState(null); // null=loading, false=hide, true=show

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/venues/map`);
        if (cancelled) return;
        setHasPins((r.data?.count || 0) > 0);
      } catch {
        setHasPins(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!hasPins) return null;

  return (
    <section data-testid="homepage-venue-map" style={{
      background: WALNUT, padding: 'clamp(70px, 9vw, 110px) clamp(20px, 5vw, 60px)',
      borderTop: `1px solid rgba(212,170,82,0.12)`,
      borderBottom: `1px solid rgba(212,170,82,0.12)`,
    }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            fontFamily: SERIF, fontStyle: 'italic',
            fontSize: 11, letterSpacing: '0.32em', textTransform: 'uppercase',
            color: GOLD, marginBottom: 14,
          }}>✦ Where we&apos;ve been</div>
          <h2 style={{
            fontFamily: SERIF, fontWeight: 500,
            fontSize: 'clamp(28px, 4.2vw, 44px)', color: IVORY,
            margin: 0, letterSpacing: '-0.02em', lineHeight: 1.1,
          }}>An evening already lit, somewhere on this map.</h2>
          <p style={{
            fontFamily: SERIF, fontStyle: 'italic',
            color: IVORY_DIM, maxWidth: 540, margin: '18px auto 0',
            fontSize: 15, lineHeight: 1.65,
          }}>
            Every pin is a real EventDrop event. Hover to see the venue, the package and a snippet
            from the customer&apos;s own words.
          </p>
        </div>
        <VenueMap variant="preview" />
        <div style={{ textAlign: 'center', marginTop: 28 }}>
          <Link to="/venues" data-testid="homepage-venue-map-cta" style={{
            display: 'inline-block', background: 'transparent', color: GOLD,
            border: `1px solid ${GOLD}`, borderRadius: 999,
            padding: '12px 26px', fontFamily: SERIF, fontSize: 13,
            letterSpacing: '0.18em', textTransform: 'uppercase',
            textDecoration: 'none', transition: 'all 200ms ease',
          }}>Explore Venue Collection ✦</Link>
        </div>
      </div>
    </section>
  );
};

export default HomepageVenueMap;
